module.exports = __webpack_public_path__ + "static/media/ginny.b9a8ac91.webp";